export const GAME_MESSAGE = 'Failed to load game data. Please retry.'
